import React, { useState, useRef } from 'react';
import styles from "./twofactors.module.css";

import { InputField, SubmitButton, TextComponent } from '../../../components';
import HeadingComponent from '../../../components/HeadingComponent/HeadingComponent';
import CheckBox from '../../../components/Checkbox/CheckBox';

const TwoFactors = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const toggle2FA = () => {
    setIsEnabled(!isEnabled);
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);


    if (value && index < 3) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  return (
    <div className={styles.AccountContent}>
      <TextComponent text={"Two Factor Authentication"} className={styles.labelText} divStyle={{ marginTop: 30, marginBottom: 10 }} />

      {/* Enable Two Factor Authentication with Switch */}
      <div className={styles.enableToggle}>
        <TextComponent text={"Enable Two Factor Authentication"} />
        <label className={styles.switch}>
          <input type="checkbox" checked={isEnabled} onChange={toggle2FA} />
          <span className={styles.slider}></span>
        </label>
      </div>

      {/* Checkboxes with Labels */}
      <TextComponent text={"Where would you like to get your verification code?"} className={styles.labelText} divStyle={{ marginTop: 30, marginBottom: 10 }} />
      <CheckBox onClick={onChange} >SMS</CheckBox>
      <CheckBox onClick={onChange}>Email</CheckBox>

      {/* OTP Message */}
      <TextComponent text={"4-digit Verification code has been sent to your registered Email address"} className={styles.labelText} divStyle={{ marginTop: 30, }} />

      {/* OTP Inputs */}
      <div className={styles.otpContainer}>
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={inputRefs[index]}
            type="text"
            className={styles.otpInput}
            value={digit}
            onChange={(e) => handleOtpChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            maxLength="1"
          />
        ))}
      </div>

      <SubmitButton
        title={'Enable Two Factor Authentication'}
        primary
        style={{ width: "70%", marginTop: "30px" }}
      />
    </div>
  );
}

export default TwoFactors;
